
const SignalGeneration = () => {
  return (
    <section className="py-32 bg-dark-lighter relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-beige-light mb-6">
            Karar Üretim Yaklaşımı
          </h2>
          <p className="text-xl text-beige/70 max-w-3xl mx-auto">
            BAGA, karmaşık analiz sonuçlarını sade ve eyleme geçirilebilir kararlara dönüştürür
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold text-beige-light mb-6">
              ALIM Kararı
            </h3>
            <p className="text-beige/70 leading-relaxed mb-6">
              Bir hisse için ALIM kararı üretildiğinde, bu hissenin teknik göstergelerinin ve makine öğrenimi modellerinin pozitif bir görünüm sergilediği anlamına gelir.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-emerald/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-emerald text-sm"></i>
                </div>
                <div>
                  <h4 className="text-beige-light font-semibold mb-1">Teknik Göstergeler Pozitif</h4>
                  <p className="text-beige/50 text-sm">Algoritmik göstergeler alım bölgesinde</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-emerald/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-emerald text-sm"></i>
                </div>
                <div>
                  <h4 className="text-beige-light font-semibold mb-1">Hacim Artışı</h4>
                  <p className="text-beige/50 text-sm">İşlem hacminde anlamlı artış gözlemleniyor</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-emerald/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-emerald text-sm"></i>
                </div>
                <div>
                  <h4 className="text-beige-light font-semibold mb-1">ML Model Skoru Yüksek</h4>
                  <p className="text-beige/50 text-sm">Makine öğrenimi modeli yüksek güven skoru veriyor</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-dark-card border border-emerald/30 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-emerald/20 rounded-xl flex items-center justify-center">
                <i className="ri-arrow-up-line text-emerald text-2xl"></i>
              </div>
              <div>
                <div className="text-emerald font-bold text-sm">ALIM KARARI</div>
                <div className="text-beige-light font-semibold text-lg">THYAO</div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-beige/70 text-sm">Karar Skoru</span>
                <div className="flex items-center gap-2">
                  <div className="w-32 h-2 bg-dark-lighter rounded-full overflow-hidden">
                    <div className="w-4/5 h-full bg-gradient-to-r from-emerald to-emerald-light"></div>
                  </div>
                  <span className="text-emerald font-semibold text-sm">80%</span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-beige/70 text-sm">Güven Seviyesi</span>
                <span className="text-beige-light font-semibold text-sm">Yüksek</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-beige/70 text-sm">Risk Seviyesi</span>
                <span className="text-yellow-400 font-semibold text-sm">Orta</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="bg-dark-card border border-blue-500/30 rounded-2xl p-8 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center">
                <i className="ri-eye-line text-blue-400 text-2xl"></i>
              </div>
              <div>
                <div className="text-blue-400 font-bold text-sm">İZLE KARARI</div>
                <div className="text-beige-light font-semibold text-lg">EREGL</div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-beige/70 text-sm">Karar Skoru</span>
                <div className="flex items-center gap-2">
                  <div className="w-32 h-2 bg-dark-lighter rounded-full overflow-hidden">
                    <div className="w-3/5 h-full bg-gradient-to-r from-blue-500 to-blue-400"></div>
                  </div>
                  <span className="text-blue-400 font-semibold text-sm">60%</span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-beige/70 text-sm">Güven Seviyesi</span>
                <span className="text-beige-light font-semibold text-sm">Orta</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-beige/70 text-sm">Risk Seviyesi</span>
                <span className="text-emerald font-semibold text-sm">Düşük</span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <h3 className="text-3xl font-bold text-beige-light mb-6">
              İZLE Kararı
            </h3>
            <p className="text-beige/70 leading-relaxed mb-6">
              İZLE kararı, hissenin henüz net bir yön belirlemediği veya mevcut pozisyonların takip edilmesi gerektiği durumlarda üretilir.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-blue-400 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-beige-light font-semibold mb-1">Kararsız Göstergeler</h4>
                  <p className="text-beige/50 text-sm">Teknik göstergeler net bir yön göstermiyor</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-blue-400 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-beige-light font-semibold mb-1">Konsolidasyon Dönemi</h4>
                  <p className="text-beige/50 text-sm">Hisse belirli bir aralıkta hareket ediyor</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-blue-400 text-sm"></i>
                </div>
                <div>
                  <h4 className="text-beige-light font-semibold mb-1">Bekleme Pozisyonu</h4>
                  <p className="text-beige/50 text-sm">Yeni bir hareket için bekleme önerisi</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 bg-gradient-to-r from-dark-card to-dark-card/50 border border-dark-border rounded-2xl p-12 text-center">
          <i className="ri-information-line text-emerald text-4xl mb-4"></i>
          <h3 className="text-2xl font-bold text-beige-light mb-4">
            Önemli Hatırlatma
          </h3>
          <p className="text-beige/70 leading-relaxed max-w-3xl mx-auto">
            BAGA kararları, yatırım tavsiyesi değildir. Tüm analizler bilgilendirme amaçlıdır ve yatırım kararlarınız için bir girdi olarak kullanılmalıdır. Yatırım yapmadan önce kendi araştırmanızı yapın ve risk toleransınızı değerlendirin.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SignalGeneration;
